<template>
  <v-container fluid style="max-width: 600px;">
    <template v-if="hasFoundData">
      <v-card class="mb-8">
        <div class="text-right mr-4 mb-n4">
          <v-avatar size="48" color="grey lighten-2 rounded-t-0">
            <v-icon color="grey darken-2">
              mdi-account
            </v-icon>
          </v-avatar>
        </div>

        <v-card-title class="justify-center text-center">
          {{ userData.name }}
        </v-card-title>

        <v-card-subtitle class="text-center">
          @{{ userData.username }}
        </v-card-subtitle>

        <v-divider />

        <user-personal-info dense :user-data="userData" />
      </v-card>

      <v-card>
        <v-card-title>
          Atualizar senha
        </v-card-title>

        <v-card-text>
          <update-password-form
            ref="updatePasswordForm"
            :loading="isSendingInfo"
            @submit="(fields) => updateUserPassword(fields)"
          />
        </v-card-text>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import api from '@/services/api';
import store from '@/services/store';

import { getPasswordUpdateFailureOptions } from '../utils/error-utils';

import UpdatePasswordForm from '../components/UpdatePasswordForm.vue';
import UserPersonalInfo from '../components/UserPersonalInfo.vue';

export default {
  name: 'ProfileView',

  components: {
    UpdatePasswordForm,
    UserPersonalInfo,
  },

  data: () => ({
    userData: null,

    isSendingInfo: false,
  }),

  computed: {
    hasFoundData: (vm) => Object.keys(vm.userData ?? {}).length > 0,
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      store.dispatch('layout/setLoadingState', true);

      try {
        const { data } = await api.profile.getMyInfo();

        this.userData = data.user;
      } catch (error) {
        store.dispatch('alert/showAlert', { errorList: [error.message] });
      } finally {
        store.dispatch('layout/setLoadingState', false);
      }
    },

    async updateUserPassword(fields) {
      this.isSendingInfo = true;

      try {
        await api.profile.updateUserPassword({
          password: fields.currentPassword,
          newPassword: fields.newPassword,
        });

        store.dispatch('alert/showAlert', {
          icon: 'mdi-check',
          iconColor: 'success',
          title: 'Senha atualizada com sucesso!',
          message: 'Utilize a nova senha na próxima vez que acessar o sistema.',
        });

        this.$nextTick(() => this.$refs.updatePasswordForm?.$refs.form?.reset());
      } catch (error) {
        store.dispatch('alert/showAlert', getPasswordUpdateFailureOptions(error));
      } finally {
        this.isSendingInfo = false;
      }
    },
  },
};
</script>
